$.extend($.validator.messages, {
  required: "Поле должно быть заполнено",
  remote: "Пожалуйста, введите правильное значение",
  email: "Введите корректную электронную почту",
  url: "Пожалуйста, введите корректный URL",
  date: "Пожалуйста, введите корректную дату",
  dateISO: "Пожалуйста, введите корректную дату в формате ISO",
  number: "Пожалуйста, введите число",
  digits: "Пожалуйста, вводите только цифры",
  creditcard: "Пожалуйста, введите правильный номер кредитной карты",
  equalTo: "Пароли не совпадают",
  extension: "Пожалуйста, выберите файл с правильным расширением",
  maxlength: $.validator.format( "Максимальная длина описания - {0} символов" ),
  minlength: $.validator.format( "Пожалуйста, введите не меньше {0} символов" ),
  rangelength: $.validator.format( "Пожалуйста, введите значение длиной от {0} до {1} символов" ),
  range: $.validator.format( "Пожалуйста, введите число от {0} до {1}" ),
  max: $.validator.format( "Максимальная длина описания - {0} символов" ),
  min: $.validator.format( "Пожалуйста, введите число, большее или равное {0}" ),
});

window.validationInit = function() {
  if ($('.js-validate').length > 0) {
    $('.js-validate').each(function(index, form) {
      $(form).validate({
        ignore: ':hidden',
        errorElement: 'span',
        errorClass: 'label-error',
        rules : {
            'password_confirm' : {
            equalTo : '.js-passwordNew'
          },
        },
        highlight: function(element) {
          setTimeout(function() {
            if(!$(element).attr('disabled')){
              $(element).parent().addClass('is-error');

              if($(element).attr('type') == 'checkbox' || $(element).hasClass('js-select2Single') || $(element).attr('type') == 'radio'){
                const parent = $(element).parent();

                parent.append(parent.find('.label-error'));
              }
            }
          });
        },
        unhighlight: function(element) {
          setTimeout(function() {
            if(!$(element).attr('disabled')){
              if($(element).val() != '') $(element).parent().addClass('is-success');
              $(element).parent().removeClass('is-error');
            }
          });
        }
      });

      $('input:not(.js-passwordNew), textarea, select', $(form)).on('focus change keyup', function() {
        const valid = $(form).validate().checkForm();
        const submit = $(form).find('[type="submit"]');

        setTimeout(function() {
            if(valid){
          submit.prop('disabled', false);
            }
            else {
          submit.prop('disabled', true);
            }
        }, 100);
      });
    });
  }

  $(document).ready(function() {
    $('.js-onlyText').bind("change keyup input click", function() {
     if (this.value.match(/[^а-яА-Яa-zA-Z\s]/g)) {
        this.value = this.value.replace(/[^а-яА-Яa-zA-Z\s]/g, '');
      }
    });
  });

  $(document).on('change keyup input click', '.js-onlyNumber', function(){
    if (this.value.match(/[^0-9.,]/g)) {
        this.value = this.value.replace(/[^0-9.,]/g, '')
    }

    return false;
  });

  // Фильтрация ввода для ИНН - только цифры
  $(document).on('change keyup input click', '.js-inn', function(){
    if (this.value.match(/[^0-9]/g)) {
        this.value = this.value.replace(/[^0-9]/g, '');
    }
    return false;
  });

  /*
   * Валидация телефона
   */

  $.validator.addMethod('phonecustom', function(value, element) {
    if(value == '+7 (___) ___-__-__') return true;
    return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{2}\-[0-9]{2}$/);
  }, 'Указан неверный формат телефона.');

  $.validator.addClassRules('js-phone', {
    phonecustom: true
  });

  /*
   * Валидация ИНН
   */

  $.validator.addMethod('inn', function(value, element) {
    // Удаляем все нецифровые символы
    const inn = value.replace(/\D/g, '');
    
    // Проверка длины
    if (inn.length < 10) {
      return false;
    }
    if (inn.length === 11) {
      return false;
    }
    if (inn.length > 12) {
      return false;
    }
    
    // Проверка контрольной суммы для 10-значного ИНН (юр. лицо)
    if (inn.length === 10) {
      const coefficients = [2, 4, 10, 3, 5, 9, 4, 6, 8];
      let sum = 0;
      
      for (let i = 0; i < 9; i++) {
        sum += parseInt(inn[i]) * coefficients[i];
      }
      
      const controlDigit = sum % 11;
      const expectedControlDigit = controlDigit < 10 ? controlDigit : 0;
      const actualControlDigit = parseInt(inn[9]);
      
      return expectedControlDigit === actualControlDigit;
    }
    
    // Проверка контрольной суммы для 12-значного ИНН (физ. лицо/ИП)
    if (inn.length === 12) {
      // Первая контрольная цифра (11-я позиция, индекс 10)
      const coefficients1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
      let sum1 = 0;
      
      for (let i = 0; i < 10; i++) {
        sum1 += parseInt(inn[i]) * coefficients1[i];
      }
      
      const controlDigit1 = sum1 % 11;
      const expectedControlDigit1 = controlDigit1 < 10 ? controlDigit1 : 0;
      const actualControlDigit1 = parseInt(inn[10]);
      
      if (expectedControlDigit1 !== actualControlDigit1) {
        return false;
      }
      
      // Вторая контрольная цифра (12-я позиция, индекс 11)
      const coefficients2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
      let sum2 = 0;
      
      for (let i = 0; i < 11; i++) {
        sum2 += parseInt(inn[i]) * coefficients2[i];
      }
      
      const controlDigit2 = sum2 % 11;
      const expectedControlDigit2 = controlDigit2 < 10 ? controlDigit2 : 0;
      const actualControlDigit2 = parseInt(inn[11]);
      
      return expectedControlDigit2 === actualControlDigit2;
    }
    
    return false;
  }, 'ИНН введён некорректно');

  $.validator.addClassRules('js-inn', {
    inn: true
  });
}

document.querySelectorAll('.js-validate').forEach(elem => {
  elem.addEventListener('submit', event => {
    const submitButton = event.target.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
    }
  });
});


// function notEmpty() {
//   $('input:not(.js-uploadFileInput), textarea').each(function() {
//     if ($(this).val().length > 0) {
//       $(this).addClass('has_value');
//     }
//   });
// }

// notEmpty();

// $(document).on('input', 'input:not(.js-uploadFileInput), textarea', function() {
//   const _this = $(this);
//   if (_this.val().length > 0) {
//     _this.addClass('has_value');
//   } else {
//     _this.removeClass('has_value');
//   }
// });

validationInit();